module.exports = __webpack_public_path__ + "img/valuesSymbol.fea80c1a.svg";